import {fetchMaintenanceTime} from '../Actions/configAction';

export default (dispatch) => {
    return {
        fetchMaintenanceTime: () => {
            dispatch(fetchMaintenanceTime());
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/configDispatch.ts